<!-- <!--
 * @Description: 会议底部
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-05-26 10:39:45
 * @LastEditors: 山淑兰
 -->
<template>
	<!-- <div class="meetFooter reds" ref="footsd">
		<a href="https://mp.weiqihd.com/msite/site/10351/"><img src="@assets/Logo.png" alt class="wqzhlogo" /></a>
		提供技术支持
	</div> -->
	<div class="meetFooter reds" ref="footsd">
		<a :href="footInfo.LogoLink"><img :src="footInfo.LogoImg" alt class="wqzhlogo" /></a>
		{{footInfo.LogoTxt}}
	</div>
</template>
<script>
	export default {
		name: 'meetFooter',
		data() {
			return {
				win_h: document.body.scrollHeight,
				LogoTxt: '',
				LogoLink: '',
				LogoImg: '',
			}
		},
		props: [
			'footInfo',
		],
		wacth: {
			win_h() {
				this.windowH()
			}
		},
		created() {
			//this.init();
			console.log('111111',this.footInfo)

		},
		methods: {
			async init() {
				try {
					const params = {
						m: this.$route.query.m
					};
					const res = await this.$http.initMeetingInfo(params);
					//console.log('底部',res)
					this.LogoTxt = res.LogoTxt
					this.LogoLink = res.LogoLink
					this.LogoImg = res.LogoImg
					//console.log(this.LogoTxt )
				} catch (error) {
					console.error(error);
				}
			},
			windowH() {
				window.onresize = () => {
					if (document.body.scrollHeight < this.win_h) {
						this.$refs.foot.style.display = 'none'
					} else {
						this.$refs.foot.style.display = 'block'
					}
				}
			}
		},
		mounted() {
			this.windowH()
		}
	}
</script>
<style lang="scss" scoped>
	.meetFooter {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(8px);
		padding: 16px 10px;
		text-align: center;
		font-size: 24px;
		box-sizing: border-box;
		border-top: 1px solid #e2e8f0;
		color: #64748b;
		box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.04);

		.wqzhlogo {
			height: 40px;
			margin-right: 14px;
			vertical-align: middle;
		}
	}
</style>
-->
